import CryptoJS from 'crypto-js';

const secretKey = 'MGBrasilExtremos';
const key = CryptoJS.enc.Utf8.parse(secretKey);


export const encryptPassword = (password) => {
    const textoCifrado = 
        CryptoJS.AES.encrypt(password, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return textoCifrado.toString();
}

export const decryptPassword = (encryptedPassword) => {
    const bytes = CryptoJS.AES.decrypt(encryptedPassword, key);
    return bytes.toString(CryptoJS.enc.Utf8);
}